// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3SOo2","ranges":"BmiRanges_ranges__CY17h"};